import { CheckCircle } from '@mui/icons-material';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { LP_CAPITAL_ACTION_LIST } from 'adminConstants/routes';
import Column from 'components/Layout/Column';
import { Link as RouterLink } from 'react-router-dom';

const StyledColumn = styled(Column)(() => ({
  justifyContent: 'center',
  height: '100%',
}));

const Complete: React.FC = () => {
  return (
    <StyledColumn spacing="xl" fullWidth centered>
      <Column spacing="lg" centered fullWidth>
        <CheckCircle color="primary" fontSize="large" />
        <Typography variant="h4" align="center">
          Capital notices published successfully
        </Typography>
        <Typography variant="body2" align="center">
          Your capital notices have been processed and sent to investors. They
          are viewable in the <i>Action Manager</i> table.
        </Typography>
      </Column>
      <Button
        component={RouterLink}
        size="large"
        variant="contained"
        to={LP_CAPITAL_ACTION_LIST}
      >
        View Action Manager
      </Button>
    </StyledColumn>
  );
};

export default Complete;
